import { createReducer } from 'utils/reduxCreators';
import { fetchCancellationReasons } from 'services/cancellationReasons';
import { isNotEmptyArray } from 'utils/misc';

export const UPDATE_CANCELLATION_REASONS =
  'cancellation/UPDATE_CANCELLATION_REASON';
export const UPDATE_CURRENT_ADFIT_NO = 'cancellation/UPDATE_CURRENT_USER';

const initialState = {
  entities: null,
  currentAccountAdfitNo: null,
};

export default createReducer(initialState, {
  [UPDATE_CANCELLATION_REASONS]: (state, { payload }) => {
    return {
      ...state,
      entities: payload,
    };
  },
  [UPDATE_CURRENT_ADFIT_NO]: (state, { payload }) => {
    return {
      ...state,
      currentAccountAdfitNo: payload,
    };
  },
});

export const forceGetCancelReasons = (adfitNo) => async (dispatch) => {
  const formatCancelReason = (reasons) => {
    if (!isNotEmptyArray(reasons)) return reasons;

    return reasons.map((reason) => ({
      label: reason,
      value: reason,
    }));
  };

  const result = await fetchCancellationReasons(adfitNo);

  dispatch({
    type: UPDATE_CANCELLATION_REASONS,
    payload: formatCancelReason(result),
  });
  dispatch({
    type: UPDATE_CURRENT_ADFIT_NO,
    payload: adfitNo,
  });
};

export const checkAndGetCancellationReasons =
  (adfitNo) => async (dispatch, getState) => {
    const {
      cancellationReasons: { currentAccountAdfitNo },
    } = getState();
    if (currentAccountAdfitNo && currentAccountAdfitNo === adfitNo) {
      return;
    }
    return dispatch(forceGetCancelReasons(adfitNo));
  };
